import { jwtDecode } from "jwt-decode";
import { paths } from "@/config/paths";
import useCurrentUser, { type AuthState } from "@/store/useCurrentUser";

/**
 * Validates if a JWT token is expired
 */
export const isTokenExpired = (token: string): boolean => {
  try {
    const decoded = jwtDecode<{ exp: number }>(token);
    if (!decoded.exp) return true;
    // Check if expired (convert exp to milliseconds)
    return decoded.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

/**
 * Validates the current token and clears auth state if expired
 * Returns true if token is valid, false if expired/invalid
 */
export const validateToken = (): boolean => {
  const { token, removeUser } = useCurrentUser.getState() as AuthState;

  if (!token) return false;

  if (isTokenExpired(token)) {
    removeUser();
    // Redirect to login
    const redirectTo = window.location.pathname;
    window.location.href = paths.auth.login.getHref(redirectTo);
    return false;
  }

  return true;
};
